import * as a from "@turf/turf";
import { areaLocationInfo as l } from "./index.es266.js";
import { cbsa as k, dma as x, nationwide as O, state as C } from "./index.es266.js";
const u = (e) => e.type === "chain" ? !0 : e.profile ? e.profile === "available" : !1, f = (e, t = 250) => {
  if (e.type === "chain" && e.area)
    return a.bboxPolygon(l[e.area.type][e.area.code].bbox);
  if (u(e) && e.geojson && (e.geojson.type === "Polygon" || e.geojson.type === "MultiPolygon"))
    return a.feature(e.geojson);
  {
    const { lat: r, lng: n } = e.geolocation, o = a.point([n, r]);
    return a.buffer(o, t, { units: "feet" });
  }
}, g = (e) => {
  var t, r;
  return ((t = e == null ? void 0 : e.category_info) == null ? void 0 : t.group) === "Shopping Centers" && (e == null ? void 0 : e.type) === "complex" || ((r = e == null ? void 0 : e.category_info) == null ? void 0 : r.group) === "Shopping Centers" && (e == null ? void 0 : e.poiType) === "complex";
}, c = (e = "", t) => t ? `${t} • ${e}` : e, v = (e) => {
  var t, r, n, o;
  const s = ((t = e.address) == null ? void 0 : t.address_label) ?? ((r = e.category_info) == null ? void 0 : r.primary) ?? e.category, i = c(
    ((n = e.address) == null ? void 0 : n.short_formatted_address) || ((o = e.address) == null ? void 0 : o.formatted_address) || "",
    s
  ), d = e.market_code;
  return d ? `${i} #${d}` : i;
}, _ = (e) => {
  var t;
  return ((t = e == null ? void 0 : e.provider_data) == null ? void 0 : t.entity_type) === "address";
}, b = (e) => e.type === "chain", m = (e) => e.type === "billboard", P = (e) => e.entity_section === "market";
export {
  l as areaLocationInfo,
  k as cbsa,
  x as dma,
  v as formatMarketName,
  f as getPOIPolygonByVerification,
  _ as isAddressPOI,
  m as isBillboard,
  b as isChainPOI,
  P as isMarketEntity,
  u as isPOIVerifiedOrAvailable,
  g as isShoppingCenterPOI,
  O as nationwide,
  C as state
};
//# sourceMappingURL=index.es281.js.map
